import React from "react";
import {Route, Redirect} from "react-router-dom";
import {withTracker} from "../libs/withTracker";
import {getLanguageFromPath} from "../utils/language";


// import {Helmet} from "react-helmet";

function querystring(name, url = window.location.href) {
    name = name.replace(/[[]]/g, "\\$&");

    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i");
    const results = regex.exec(url);

    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// eslint-disable-next-line import/no-anonymous-default-export
export default ({component: C, props: cProps, ...rest}) => {
    const redirect = querystring("redirect");
    const routeLanguage = getLanguageFromPath(window.location.pathname);

    if (cProps.language !== routeLanguage) {
        cProps.language = routeLanguage;
        cProps.setSiteLanguage(routeLanguage);
    }

    withTracker(rest.path + '_' + cProps.language);
    return (
        <div>
            {/*<Helmet>*/}
            {/*    {isGerman ?*/}
            {/*        <link rel="canonical" href="https://camdiab.com/de"/> :*/}
            {/*        <link rel="canonical" href="https://camdiab.com"/>*/}
            {/*    }*/}
            {/*</Helmet>*/}

            <Route
                {...rest}
                render={props =>
                    !cProps.isAuthenticated
                        ? <C {...props} {...cProps} />
                        : <Redirect
                            to={redirect === "" || redirect === null ? "/" : redirect}
                        />}
            />
        </div>
    );
};
